import { ERROR_ORIGIN } from "clientState/GoogleIdentityProvider/GoogleTrackingErrorProvider/TrackingErrorComponent";

import type { GetInitializerType, IsButtonSelectedByType } from "./contract";
import { GOT } from "./stateOptions";

// select_by will be one of the defined select by values in https://developers.google.com/identity/gsi/web/reference/js-reference#select_by
export const SELECTED_BY = {
  auto: false,
  user: false,
  fedcm: false,
  fedcm_auto: false,
  user_1tap: false,
  user_2tap: false,
  btn: true,
  btn_confirm: true,
  btn_add_session: true,
  btn_confirm_add_session: true,
} as const;

const isButtonSelectedBy: IsButtonSelectedByType = (select_by) =>
  !!SELECTED_BY[select_by];

export const getInitializer: GetInitializerType = ({ select_by, state }) => {
  const isButton = isButtonSelectedBy(select_by);
  if (!state && isButton) {
    window.document.getElementById(ERROR_ORIGIN.select_by)?.click();
  }
  return isButton ? state : GOT;
};
